import { IPartner } from 'types';
import { base } from 'api';

const PATH = '/partner';

const get = (id: number) => base.get(`${PATH}/${id}`);

const getAll = () => base.get(PATH);

const post = (data: Omit<IPartner, 'id'>) => base.post(PATH, data);

const patch = ({ id, ...data }: IPartner & { isNewFile: boolean }) =>
  base.patch(`${PATH}/${id}`, data);

export { get, getAll, post, patch };
